import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { PricingPanelComponent } from './lib/pricing-panel.component'
import { PricingKey } from './panel-key'

export * from './lib/pricing.module'
export * from './panel-key'

export const PricingPanelConfig: PanelConfig = {
  key: PricingKey,
  title: 'Pricing',
  description:
    'Compare available sources of market prices and analytics for a selected security.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: PricingPanelComponent,
  accessPermission: 'accessPricingPanel',
}
